const legendMobile = () => {
  const btn = document.getElementById('btn-legend-indicator')
  if (btn) {
    const legendWrapper = document.querySelector('.legend-wrapper')
    btn.addEventListener('click', (event) => {
      legendWrapper.classList.toggle('d-none');
      event.currentTarget.querySelectorAll('span')[1].classList.toggle('d-none');
      event.currentTarget.querySelectorAll('span')[2].classList.toggle('d-none')

    })
  }
}

// const legendCount = () => {

//   const btns = document.querySelectorAll('.btns-tilsets')
//   btns.forEach((btn) => {
//     btn.addEventListener('click', (event) => {
//       const count = countLegend()
//       const box = document.getElementById('btn-legend-indicator')
//       box.innerHTML = ''
//       const html = `
//       <span class='count-badge'>${count}</span>
//       <span class="fr-fi-arrow-left-s-line" aria-hidden="true"></span>
//       `
//       box.insertAdjacentHTML('beforeend', html)
//       console.log(count)
//     })
//   })
// }


const addLegendMobileOnClick = () => {
  const btn = document.getElementById('btn-legend-indicator');
  if (btn) {
    const count = countLegend()
    const box = document.getElementById('btn-legend-indicator')
    box.innerHTML = ''
    const html = `
    <span class='count-badge'>${count}</span>
    <span class="ri-arrow-left-s-line icone-customize-lg" aria-hidden="true"></span>
    <span class="ri-arrow-right-s-line icone-customize-lg d-none" aria-hidden="true"></span>
    `
    box.insertAdjacentHTML('beforeend', html)

  }
}
const countLegend = () => {
  let i = 0
  const legendWrapper = document.querySelector('.legend-wrapper')
  const legendBoxs = legendWrapper.querySelectorAll('.legend-box')
  legendBoxs.forEach((legendBox) => {
    if (!(legendBox.classList.contains('d-none'))) {
      i = i + 1
    }
  })
  return i
}

export { legendMobile, addLegendMobileOnClick }
